import React, { useContext, useState } from "react";
import styles from "./styles/Payment.module.css";
import PaymentMethodElement from "../../Payment/PaymentMethodElement";
import { PaymentSuccess } from "./PaymentSuccess";
import { createPaymentMethod } from "../../../Utils/StripeUtils";
import { UserData } from "../../../Context/DataContext";
import config from "../../../config";
import { useEffect } from "react";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import useSubscriptionData from "../../../Utils/useSubscriptionData";
const base_url = config.base_url;
function Payment({
  onExpand = null,
  cardDetails,
  expandable = true,
  expanded = false,
}) {
  const [expand, setExpand] = useState(false);
  const [paymentData, setPaymentData] = useState();
  const userData = UserData();
  const billingData = UserData().BillingData;
  const [elements, setElements] = useState();
  const [stripe, setStripe] = useState();
  const [success, setSuccess] = useState();
  const [error, setError] = useState();
  const [processing, setProcessing] = useState(false);
  const [card, setCard] = useState(cardDetails);
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );

  const [content, setContent] = useState(
    websiteCurrentLang.content.User.MyAccount.Payment
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.MyAccount.Payment);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  useEffect(() => {
    if (expanded) setExpand(true);
  }, [expanded]);
  useEffect(() => {
    setCard(cardDetails);
    if (cardDetails?.error) setExpand(true);
  }, [cardDetails]);
  const changePayment = () => {
    const name = `${billingData.first_name}${
      billingData.type === "Individual" ? ` ${billingData.last_name}` : ""
    }`;
    createPaymentMethod(stripe, elements, {
      email: billingData.email,
      address: { line1: billingData.address },
      name: name,
    })
      .then((paymentMethod) => {
        setProcessing(true);
        const payment_id = paymentMethod?.paymentMethod?.id;
        if (!payment_id) throw new Error();
        setCard(paymentMethod?.paymentMethod);
        fetch(base_url + "user/payment/update", {
          method: "POST",
          mode: "cors",
          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-type": "application/x-www-form-urlencoded",
            credentials: "include",
          },
          credentials: "include",
          body: `paymentMethod=${payment_id}`,
        })
          .then((res) => {
            if (res.status === 200) {
              userData.getBillingData();
              return setSuccess(true);
            } else throw new Error();
          })
          .then((e) => {
            setProcessing(false);
          })
          .catch((e) => {
            console.log(e);
            setProcessing(false);
            setError(dublicatedcontent?.dublicatedText78);
            setTimeout(() => {
              setError();
            }, 5000);
            throw new Error();
          });
      })
      .catch((e) => {
        console.log(e);
        setError(dublicatedcontent?.dublicatedText78);
        setTimeout(() => {
          setError();
        }, 5000);
        setProcessing(false);
      });
  };
  const subscriptionData = useSubscriptionData(dublicatedcontent);

  return (
    <>
      {!card?.error && (
        <div className={styles.main}>
          <div className={styles.visa_card_method}>
            <div className={styles.visa_card_method_sub}>
              <div className={styles.visa_logo}></div>
              <div className={styles.card_number}>
                {card ? (
                  `XXXX-XXXX-XXXX-${card?.card?.last4}`
                ) : (
                  <div className={styles.loading_bar}>
                    <div className={styles.loading_bar_inner}></div>
                  </div>
                )}
              </div>
            </div>
            {+subscriptionData?.years !== 100 && !expand ? (
              <div
                onClick={() => {
                  setExpand(true);
                  onExpand();
                }}
                className={styles.change_text}
              >
                {content.paymentText1}
              </div>
            ) : null}
          </div>
        </div>
      )}
      {((expand && expandable) || !cardDetails) && (
        // <PaymentStripe setExpand={setExpand} />
        <>
          <PaymentMethodElement
            onChange={(e) => setPaymentData(e)}
            setStripe={(e) => setStripe(e)}
            setElements={(e) => setElements(e)}
            language={websiteCurrentLang?.label}
          />
          {
            <div
              className={styles.buttons_div}
              style={{ display: paymentData ? "flex" : "none" }}
            >
              <button
                className={styles.cancel}
                onClick={(e) => setExpand(false)}
              >
                {dublicatedcontent?.dublicatedText184}
              </button>
              <button
                className={styles.submit}
                onClick={(e) => changePayment()}
              >
                {processing
                  ? dublicatedcontent?.dublicatedText50
                  : dublicatedcontent?.dublicatedText185}
              </button>
              <div className={styles.error_message}>{error}</div>
            </div>
          }
        </>
      )}
      {success && (
        <PaymentSuccess
          button={dublicatedcontent?.dublicatedText76}
          OnClose={() => {
            setSuccess(false);
            setExpand(false);
          }}
          title={content.paymentText3}
          subtitle={content.paymentText2}
        />
      )}
    </>
  );
}
export { Payment };
